import React, { Component, createRef } from "react";
import DataTable from './TableBase';
import { IconButton } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class ParasutEinboxTable extends Component {

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true
        }

    }
    handleDelete = async (customerId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz.Müşteriye ait tüm veriler silinir!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/customer/delete/' + customerId, 'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Müşteri başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleCustomerDetail = (invoiceID) => {
        this.props.history.push(`/einbox-detail/${invoiceID}`);
    }
    render() {
        const { pending } = this.state;
        const { userPermissions } = this.props;
        const userHasViewCustomerPermission = userPermissions.includes('view customer');
        const userHasDeleteCustomerPermission = userPermissions.includes('delete customer');
        const columns = [
            {
                name: 'ID',
                selector: row => row.id,
                sortable: true
            },

            {
                name: 'İsim',
                selector: row => row.name,
                sortable: true
            },
            {
                name: 'Vkn',
                selector: row => row.vkn
            },
            {
                name: 'Fatura No',
                selector: row => row.e_invoice_id,
                sortable: true
            },
            {
                name: 'Fatura Kayıt Tarihi',
                selector: row => row.registered_at ? mainHelper.dateFormat(row.registered_at) : ""
            },


            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>

                        {userHasDeleteCustomerPermission ? (
                            <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{ cursor: 'pointer', marginLeft: -15 }}>
                                <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                            </IconButton>
                        ) : ""}


                    </>
                )
            }

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/parasut/einbox"}
                columns={columns}
                onRowClicked={userHasViewCustomerPermission ? row => this.handleCustomerDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(ParasutEinboxTable));
